import dlzLogo from './logo-dlz.png';
import dinerLogo from './logo-diner2.png';
import scenesLogo from './logo-scenes2.png';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import BusinessIcon from '@mui/icons-material/Business';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { List, ListItem, ListItemIcon, ListItemText, Typography} from '@mui/material';


export default function HomePage() {
    return (
        <>
            {/* <Box sx={{ flexGrow: 1 , width: '100%'}}>
                <AppBar position="static" sx={{backgroundColor: '#dddddd'}}>
                    <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2, color: '#000000' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <img alt="logo" src={dlzLogo} style={{height: 50, width: 50}}/>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    </Typography>
                    <Button sx={{color:"#dddddd"}}>Login</Button>
                    </Toolbar>
                </AppBar>
            </Box> */}
            <p> 
                <img 
                    src={dlzLogo} 
                    className="diner-logo"
                    alt="logo" 
                    style={{height:400, width: 400, margin: 0}} 
                />
            </p>
        
    
            <Divider sx={{mb: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>
            
        
            <Typography variant='h3' sx={{mb:2, fontFamily: 'Roboto'}}>DLZ Ventures LLC</Typography>
            <List>
                <ListItem sx={{justifyContent: 'center'}}><i>Mobile App Development</i></ListItem>
                <ListItem sx={{justifyContent: 'center'}}><i>Digital Products</i></ListItem>
                <ListItem sx={{justifyContent: 'center'}}><i>Creative Images and Apparel</i></ListItem>
            </List>

            <Divider sx={{mt: 10, mb: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>
        

            <Typography variant='h3' sx={{mb:2}}>About</Typography>        
                <Typography sx={{width: 600, fontSize: 20}}>
                    Our team builds mobile applications and related software services
                    to assist the efficency of everyday life. While adding some
                    light-hearted fun along the way.
                    We design, develop, and maintain apps for iOS and cross‑platform
                    environments.
                </Typography>

            <Divider sx={{mt: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>


            <p> 
                <img 
                    src={dinerLogo} 
                    className="diner-logo"
                    alt="logo" 
                    style={{height: 400, width: 500, margin: 0}} 
                />
            </p>
            <p>
                <img 
                    src={scenesLogo} 
                    className="scenes-logo" 
                    alt="logo" 
                    style={{height: 400, width: 450}} 
                />
            </p>


            
            <Divider sx={{mb: 10, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>

            
            <Typography variant='h3' sx={{mb:2}}>Contact</Typography>
            <List>
                <ListItem>
                    <ListItemIcon sx={{color: '#ffffff'}}><MailOutlineIcon/></ListItemIcon>
                    <ListItemText><strong> Email: </strong> dlzventuresllc@gmail.com</ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon sx={{color: '#ffffff'}}><PhoneAndroidOutlinedIcon/></ListItemIcon>
                    <ListItemText><strong> Phone: </strong> (959) 895-7738</ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon sx={{color: '#ffffff'}}><BusinessIcon/></ListItemIcon>
                    <ListItemText><strong> Address: </strong> 25 Outlook Ave, West Hartford, CT 06119</ListItemText>
                </ListItem>
            </List>
            

            <Divider sx={{mt: 10, mb: 2, height: 1, width: 800, backgroundColor: '#ffd700'}}></Divider>


            <footer>
                <small>© {new Date().getFullYear()} DLZ Ventures LLC</small>
            </footer>
            <Box sx={{ mt: 2, flexGrow: 1 , width: '100%'}}><Paper sx={{height:50, backgroundColor: '#000000'}}/></Box>

        </>
    )
  }